import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import authReducer from "./reducer";
import { reducer as formReducer } from "redux-form";

// interface RootStore {
//   routing: Reducer<RouterState, AnyAction>;
//   auth: AuthState;
//   search: SearchState;
//   message: MessageState;
//   dashboard: DashboardState;
//   form: reducer;
// }

const appReducer = combineReducers({
  routing: routerReducer,
  auth: authReducer,
  form: formReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_ALL_DATA") {
    state = {
      auth: state.auth,
    };
  }
  return appReducer(state, action);
};

export default rootReducer;

export type RootState = ReturnType<typeof appReducer>;
